import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Button, Popover } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import moment from 'moment';

const useColumns = (callBackEdit, callBackOpenModal, enums, contracts) => {
  const { t } = useTranslation();

  return [
    {
      title: 'Contrat',
      dataIndex: 'contratId',
      key: 'contratId',
      filters: contracts?.map(({ number, _id }) => ({
        text: number,
        value: _id
      })),
      sorter: true,
      render: (contrat) => {
        return contrat?.number;
      }
    },
    {
      title: 'Objet',
      dataIndex: 'objetReclamation',
      key: 'objetReclamation',
      sorter: true
    },
    {
      title: 'Statut',
      dataIndex: 'status',
      key: 'status',
      filters: enums?.statuses.map((p) => ({
        text: t(`contracts.tags.${p}`),
        value: p
      })),
      sorter: true,
      render: (status) => {
        if (status === 'WAITING') {
          return (
            <span style={{ color: '#f50', fontWeight: 'bold' }}>
              En attente
            </span>
          );
        }

        if (status === 'IN_PROGRESS') {
          return (
            <span style={{ color: '#2db7f5', fontWeight: 'bold' }}>
              En cours
            </span>
          );
        }

        if (status === 'VALID') {
          return (
            <span style={{ color: '#87d068', fontWeight: 'bold' }}>
              Validée
            </span>
          );
        }

        if (status === 'CLOSED') {
          return (
            <span style={{ color: '#108ee9', fontWeight: 'bold' }}>
              Traitée
            </span>
          );
        }
        return '';
      }
    },
    {
      title: 'Date de création',
      key: 'created_at',
      sorter: true,
      render: (created_at) => moment(created_at).format('DD-MM-YYYY')
    },
    {
      title: 'Date de rappel',
      key: 'recallDate',
      sorter: true,
      render: (record) => {
        if (record.status !== 'IN_PROGRESS') {
          return '';
        }

        return moment(record.recallDate).format('DD-MM-YYYY');
      }
    },
    {
      render: (record) => {
        return (
          <div style={{ float: 'right' }}>
            <Divider orientation="vertical" />
            <Popover content="Traiter la réclamation">
              <Button
                type="link"
                onClick={() => callBackOpenModal(record.key)}
                style={{ padding: 0 }}
              >
                <EyeOutlined style={{ fontSize: '16px' }} />
              </Button>
            </Popover>
          </div>
        );
      }
    }
  ];
};

export default useColumns;
